import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { AlertController, LoadingController, Platform } from '@ionic/angular';
import { AttachmentService } from 'src/app/providers/forms/attachment/attachment.service';
import { UserDataService } from 'src/app/providers/userData/user-data.service';
import { CommonService } from 'src/app/providers/common/common.service';
import * as _ from 'lodash';

@Component({
	selector: 'app-office-attachment-section',
	standalone: false,
	templateUrl: './office-attachment-section.component.html',
	styleUrls: ['./office-attachment-section.component.scss']
})
export class OfficeAttachmentSectionComponent implements OnInit {
	@Input() formId;
	@Input() formTypeId;
	@Input() formStatus;
	@Input() attachments;
	@Input() keyCaptionMap;
	@Input() createdByuserId;
	@Output() attachementOfficeDocumentsEmmiter: EventEmitter<any> = new EventEmitter<any>();

	sectionOpen = false;
	files: File[] = [];
	isImageSelected = false;
	caption = '';
	isOFFICE_EQUI = false;
	isIQACADMIN = false;
	collegeManagementId;
	collegeId;
	userId;
	attachmentsWithName = [];
	isMobileApp: boolean = false;
	profile: any = {};
	subscriptionStatus: boolean = true;
	constructor(
		private alertController: AlertController,
		private attachmentService: AttachmentService,
		private loadingController: LoadingController,
		private userdataService: UserDataService,
		public platform: Platform
	) {}

	toggleSection(targetElement: HTMLElement) {
		this.sectionOpen = !this.sectionOpen;

		if (this.sectionOpen) {
			// Wait for the content to expand before scrolling
			setTimeout(() => {
				targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}, 300); // Adjust based on animation timing
		}
	}

	ngOnInit() {
		this.getProfile();
		if (this.platform.is('android')) {
			this.isMobileApp = true;
		} else {
		}
		this.userdataService.getUserProfile().then((profile) => {
			if (profile) {
				this.collegeId = profile.college.id;
				this.collegeManagementId = profile.college.managementCommittee.id;
				this.userId = profile.id;
			}
		});
		if (this.attachments === undefined) {
			this.attachments = [];
		}
		this.attachments.forEach((url, index) => {
			let attachmentWithUrl: any = {};
			attachmentWithUrl.url = url;
			attachmentWithUrl.fileName = this.deriveAttachmentNameFromUrl(url);
			let key = this.deriveAttachmentKeyFromUrl(url);
			attachmentWithUrl.key = key;
			attachmentWithUrl.caption = this.keyCaptionMap[decodeURI(key)];
			this.attachmentsWithName.push(attachmentWithUrl);
		});
		this.initRoles();
	}
	initRoles() {
		this.userdataService.getLoggedInUserRole().then((roles) => {
			if (roles) {
				if (roles.includes('IQAC_ADMIN')) {
					this.isIQACADMIN = true;
				}
				if (roles.includes('OFFICE_EQUI')) {
					this.isOFFICE_EQUI = true;
				}
			}
		});
	}
	noOfAttachmentsWithinLimit() {
		return this.attachments.length < 3 && this.isOFFICE_EQUI;
	}

	async onSelect(event) {
		CommonService.log(event);
		if (this.files.length > 0) {
			this.userdataService.presentToast('Only one Attachment file is supported to upload', 'warning');
			return;
		} else {
			// Validate size
			/* if (event.addedFiles[0].size > 2000000) {
        this.userdataService.presentToast("Attachment size should not exceed 2MB", "warning");
        return;
      } */

			// Vaidate Type
			let type = event.addedFiles[0].type;
			// Word - application/vnd.openxmlformats-officedocument.wordprocessingml.document
			// Excel - application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
			// PDF - application/pdf
			// JPG - image/jpeg
			// PNG - image/png

			/* if (_.includes(type, 'image/png') || _.includes(type, 'image/jpeg') || _.includes(type, 'image/jpg')) {
        this.files.push(...event.addedFiles);
      } else {
        this.userdataService.presentToast("Only png or jpeg images are allowed as Attachment", "warning");
        return;
      } */

			// Validate Extensions
			let name = _.lowerCase(event.addedFiles[0].name);
			if (
				_.endsWith(name, 'doc') ||
				_.endsWith(name, 'docx') ||
				_.endsWith(name, 'xls') ||
				_.endsWith(name, 'xlsx') ||
				_.endsWith(name, 'pdf') ||
				_.endsWith(name, 'png') ||
				_.endsWith(name, 'jpg') ||
				_.endsWith(name, 'jpeg')
			) {
				if (_.endsWith(name, 'png') || _.endsWith(name, 'jpg') || _.endsWith(name, 'jpeg')) {
					this.isImageSelected = true;
				} else {
					this.isImageSelected = false;
				}
				this.files.push(...event.addedFiles);
			} else {
				this.userdataService.presentToast('Only Word/Excel/PDF/Images are allowed as Attachment', 'warning');
				return;
			}
		}
	}

	onRemove(event) {
		CommonService.log(event);
		this.files.splice(this.files.indexOf(event), 1);
	}

	async uploadAttachment() {
		if (this.caption === undefined || this.caption === '') {
			this.userdataService.presentToast('Please add caption for attachment', 'warning');
			return false;
		}
		var fileName = this.files[0].name.replace(/\s+/g, '_');
		if (this.checkFileName(this.attachmentsWithName, fileName)) {
			this.userdataService.presentToast('File name already exists.', 'warning');
			return false;
		}

		const loader = await this.loadingController.create({
			message: 'Uploading Attachment...'
		});
		loader.present();
		let payload: any = {};
		payload.managementCommitteeId = this.collegeManagementId;
		payload.collageId = this.collegeId;
		payload.userId = this.createdByuserId;
		payload.formTypeId = this.formTypeId;
		payload.formId = this.formId;
		payload.fileName = ''; // For upload it will taken from file name
		payload.caption = this.caption;
		const formData = new FormData();
		formData.append('file', this.files[0], this.files[0].name);

		this.attachmentService.upload(formData, payload, 'OFFICE_DOCUMENT').subscribe(
			(response) => {
				if (response) {
					loader.dismiss();
					let urlToAttachment = response.attachmentSourceUrl;
					this.userdataService.presentToast('Attachment and Form Updated Successfully.', 'success');
					this.attachementOfficeDocumentsEmmiter.emit(urlToAttachment);
					if (this.attachments === undefined) {
						this.attachments = [];
					}
					this.attachments.push(urlToAttachment);

					// FOR UI
					let attachmentWithUrl: any = {};
					attachmentWithUrl.url = urlToAttachment;
					attachmentWithUrl.fileName = this.deriveAttachmentNameFromUrl(urlToAttachment);
					attachmentWithUrl.caption = this.caption;
					this.attachmentsWithName.push(attachmentWithUrl);
					// CommonService.log(event);
					this.files.splice(this.files.indexOf(this.files[0]), 1);
					this.caption = '';
				} else {
					loader.dismiss();
				}
			},
			(error) => {
				this.userdataService.presentToast('Attachment Addition Failed.', 'danger');
				loader.dismiss();
			}
		);
		return true;
	}

	checkFileName(obj, name) {
		return obj.some(function (gfg) {
			return gfg.fileName === name;
		});
	}

	deriveAttachmentNameFromUrl(url) {
		let untillFileName = url.substring(0, url.indexOf('?'));
		let fileName = untillFileName.substring(untillFileName.lastIndexOf('/') + 1);
		return fileName;
	}

	deriveAttachmentKeyFromUrl(url) {
		let key = url.substring(url.indexOf('.com') + 5, url.indexOf('?'));
		return key;
	}

	async confirmRemove(url) {
		const loader = await this.loadingController.create({
			message: 'Deleting Attachment...'
		});
		loader.present();
		let payload: any = {};
		payload.managementCommitteeId = this.collegeManagementId;
		payload.collageId = this.collegeId;
		payload.userId = this.createdByuserId;
		payload.formTypeId = this.formTypeId;
		payload.formId = this.formId;
		payload.fileName = decodeURI(this.deriveAttachmentNameFromUrl(url));

		this.attachmentService.delete(payload, 'OFFICE_DOCUMENT').subscribe(
			(response) => {
				if (response) {
					this.attachments.forEach((link, index) => {
						if (url === link) {
							this.attachments.splice(index, 1);
							this.attachementOfficeDocumentsEmmiter.emit(this.attachments);
						}
					});
					this.attachmentsWithName.forEach((attachment, index) => {
						if (url === attachment.url) {
							this.attachmentsWithName.splice(index, 1);
						}
					});
					this.userdataService.presentToast('Attachment Removed and Form Updated Successfully.', 'success');
				}
				loader.dismiss();
			},
			(error) => {
				this.userdataService.presentToast('Attachment Removal Failed.', 'danger');
				loader.dismiss();
			}
		);
	}

	async remove(url) {
		if (!this.isOFFICE_EQUI) {
			this.userdataService.presentToast('You are not authorised to perform attachment remove operations!', 'warning');
			return false;
		}
		const alert = await this.alertController.create({
			header: 'Remove Attachment?',
			message: 'Do you want to remove attachment ?',
			buttons: [
				{
					text: 'Yes',
					role: 'Ok',
					handler: () => {
						this.confirmRemove(url);
					}
				},
				{
					text: 'Cancel',
					role: 'cancel',
					handler: () => {
						console.log('Cancel');
					}
				}
			]
		});
		alert.present();
		return true;
	}

	isAttachmentImage(attachment: any) {
		let name = attachment.fileName;
		if (_.endsWith(name, 'png') || _.endsWith(name, 'jpg') || _.endsWith(name, 'jpeg')) {
			return true;
		}
		return false;
	}

	isPdf(attachment: any) {
		let name = attachment.fileName;
		if (_.endsWith(name, 'pdf')) {
			return true;
		}
		return false;
	}

	isWord(attachment: any) {
		let name = attachment.fileName;
		if (_.endsWith(name, 'doc') || _.endsWith(name, 'docx')) {
			return true;
		}
		return false;
	}

	isExcel(attachment: any) {
		let name = attachment.fileName;
		if (_.endsWith(name, 'xls') || _.endsWith(name, 'xlsx')) {
			return true;
		}
		return false;
	}

	download(attachment: any) {
		const link = document.createElement('a');
		link.href = attachment.url;
		link.setAttribute('download', attachment.fileName);
		link.setAttribute('target', '_blank');

		document.body.appendChild(link);
		link.click();
		link.parentNode.removeChild(link);
	}

	async editCaption(key, caption, attachment) {
		if (!this.isOFFICE_EQUI) {
			this.userdataService.presentToast('You are not authorised to perform caption edit!', 'warning');
			return false;
		}
		const alert = await this.alertController.create({
			header: 'Edit Caption',
			message: 'Please type image caption below',
			inputs: [
				{
					name: 'caption',
					type: 'textarea',
					value: caption
				}
			],
			buttons: [
				{
					text: 'Save',
					role: 'Ok',
					handler: (data) => {
						this.confirmEditCaption(key, data.caption);
						attachment.caption = data.caption;
					}
				},
				{
					text: 'Cancel',
					role: 'cancel',
					handler: () => {
						console.log('Cancel');
					}
				}
			]
		});
		alert.present();
		return true;
	}

	async confirmEditCaption(key, captionText) {
		const loader = await this.loadingController.create({
			message: 'Saving image caption'
		});
		loader.present();
		let payload: any = {};
		payload.key = key;
		payload.caption = captionText;
		this.attachmentService.editCaption(payload).subscribe(
			(response) => {
				if (response) {
				}
				loader.dismiss();
			},
			(error) => {
				this.userdataService.presentToast('Caption edit failed.', 'danger');
				loader.dismiss();
			}
		);
	}

	getProfile() {
		this.userdataService.getUserProfile().then((profile) => {
			if (profile) {
				this.profile = profile;
				console.log(this.profile);
				if (this.profile.college.status == 'SUBS_EXPIRED') {
					this.subscriptionStatus = false;
				}
			}
		});
	}
}
